<template>
    <div class="model-content">
        <div class="opera-btn">
            <el-button type="primary" @click="saveBiConfig">保存</el-button>
            <el-button  @click="cancelBiConfig">取消</el-button>
        </div>
        <div class="search-box">

        </div>
        <div class="content-box">
            <el-table stripe :data="modelList" style="width: 100%" height="500" :border="true" v-loading="loading" :class="'modelListTable'"  @current-change="clickChange">
                <el-table-column label="选择" width="55">
                     <template slot-scope="scope">
                        <el-radio v-model="tableRadio" :label="scope.row"><i></i></el-radio>
                     </template>
                 </el-table-column>
                <el-table-column prop="appName" label="所属应用" :show-overflow-tooltip="true" min-width="100"></el-table-column>
                <el-table-column prop="functionName" label="功能模块" :show-overflow-tooltip="true" min-width="100"></el-table-column>
                <el-table-column prop="modelName" label="模型名称" :show-overflow-tooltip="true" min-width="100"></el-table-column>
                <el-table-column prop="state" label="使用状态" min-width="70" :sortable="true">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.state === 1" type="success">已发布</el-tag>
                        <el-tag v-if="scope.row.state === 0" type="info">未发布</el-tag>
                    </template>
                </el-table-column>
                <!--   <el-table-column prop="trueName" label="创建人" min-width="60"></el-table-column> -->
                <el-table-column prop="authName" label="已授权人员" min-width="60" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="created" label="创建时间" :show-overflow-tooltip="true" :sortable="true" min-width="80"></el-table-column>
            </el-table>
        </div>
        <div class="page-box">
            <el-pagination
                background
                layout="total,sizes, prev, pager, next"
                :total="page.totalPageNum"
                :current-page="page.currentPage"
                :page-size="page.pageSize"
                :page-sizes="[10, 20, 30, 50, 100]"
                @current-change="queryFormData"
                @size-change="queryFormDataByPageSize"
            />
        </div>
    </div>
</template>

<script>
    import {getModelListByType} from '@/data-model';
    export default{
        props: {
            modelType: {
                type: Number,
                default: 1
            }
        },
        data () {
            return {
                modelList: [],
                loading: true,
                page: {
                    totalPageNum: 0,
                    currentPage: 1,
                    pageSize: 10
                },
                tableRadio: {}
            };
        },
        created () {
            this.initModelList();
        },
        methods: {
            async initModelList () {
                let param = {modelType: this.modelType, currentPage: this.page.currentPage, pageSize: this.page.pageSize};
                let res = await getModelListByType(param);
                if (res.state === 'success') {
                    this.modelList = res.data;
                    this.page.totalPageNum = res.count;
                } else {

                }
                this.loading = false;
                // console.log(res);
            },
            queryFormData (currentPage) {
                this.page.currentPage = currentPage;
                this.initModelList();
            },
            queryFormDataByPageSize (pageSize) {
                this.page.pageSize = pageSize;
                this.initModelList();
            },
            clickChange (item) {
                this.tableRadio = item;
            },
            saveBiConfig () {
                this.$emit('configDashBoardModelList', this.tableRadio);
            },
            cancelBiConfig () {
                this.$emit('cancelDashBoardModelList');
            }
        }
    };
</script>

<style lang="less">
    .showDashBoardModel{
        .el-dialog__header{
            display: none;
        }
        .el-dialog__body{
            padding-top: 0px;
            .model-content{
                .opera-btn{
                    height: 40px;
                    line-height: 40px;
                    text-align: right;
                    margin-bottom: 10px;
                    margin-top: 10px;
                }
                .page-box{
                    margin-top: 10px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/DataWarehousing/DashBoardModelList.vue